import Honeybadger from '@honeybadger-io/js';
import { ApolloError } from 'apollo-boost';

export const graphQLErrorMessage = (error: ApolloError) =>
  error.graphQLErrors.length > 0 && error.graphQLErrors[0].message;

export const reportError = (error: Error, context: any) => {
  Honeybadger.notify(error, { ...context });
  console.error(error, { context });
};
